import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Image } from "semantic-ui-react";
import { Photo } from "../../../../types/siteTypes";
import {
  SampleNextArrow,
  SamplePrevArrow,
} from "../../../../utils/reusableFunctions";
import ImageLightbox from "../../../../components/ImageLightbox";
import styles from "./ImageGallery.module.scss";

type Props = {
  photos: Photo[];
};

const ImageGallery: React.FC<Props> = ({ photos }) => {
  const [state, setState] = useState<any>({ nav1: null, nav2: null });
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedSlide, setSelectedSlide] = useState(0);
  const slider1: any = useRef<Slider>(null);
  const slider2: any = useRef<Slider>(null);

  useEffect(() => {
    setState({
      nav1: slider1.current,
      nav2: slider2.current,
    });
  }, []);

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleImageClick = (index: number) => {
    setSelectedSlide(index);
    setLightboxOpen(true);
  };

  return (
    <div className={styles.self}>
      <Slider
        {...settings}
        asNavFor={state.nav2}
        ref={(slider) => { slider1.current = slider; }}
        className={styles.slider}
        beforeChange={(_current: number, next: number) => setSelectedSlide(next)}
      >
        {photos.map((photo, key) => (
          <div key={`top-photos-${key}`} className={styles.slide}>
            <Image
              className={styles.topPhoto}
              src={photo.thumbnailUrl || photo.url}
              onClick={() => handleImageClick(key)}
              style={{ cursor: 'pointer' }}
            />
          </div>
        ))}
      </Slider>
      {photos.length > 1 && (
        <Slider
          asNavFor={state.nav1}
          ref={(slider) => { slider2.current = slider; }}
          slidesToShow={photos.length <= 4 ? photos.length : 4}
          swipeToSlide={true}
          centerMode={true}
          focusOnSelect={true}
        >
          {photos.map((photo, key) => (
            <div className={styles.bottonPhoto} key={`bottom-photos-${key}`}>
              <img
                src={photo.thumbnailUrl || photo.url}
                alt=""
                onClick={() => handleImageClick(key)}
                style={{ cursor: 'pointer' }}
              />
            </div>
          ))}
        </Slider>
      )}
      <ImageLightbox
        photos={photos}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        initialSlide={selectedSlide}
      />
    </div>
  );
};
export default ImageGallery;
